<template>
  <div
    id="info-wrapper"
    class="info-setting d-flex align-items-center justify-content-center"
    @click.self="isShow(false)"
  >
    <div class="info-box d-flex flex-column">
      <div class="info-head">
        <div class="media">
          <div class="media-body">
            <div class="h2">
              {{ title || "Title" }}
            </div>
          </div>
          <div class="ml-3">
            <button class="btn sc-btn sc-btn-opaque" @click="isShow(false)">
              {{ $t("button.close") }}
            </button>
          </div>
        </div>
      </div>
      <div class="info-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
  data() {
    return {};
  },
  methods: {
    isShow(flag) {
      this.$emit("isShow", flag);
    }
  }
};
</script>
<style lang="scss" scoped>
#info-wrapper {
  background-color: rgba(74, 74, 74, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 10;
  top: 0;
  left: 0;
}
.info-box {
  position: absolute;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  width: auto;
  height: auto;
  max-width: 640px;
  max-height: 480px;
}
.info-head {
  padding-top: 20px;
  padding-left: 25px;
  padding-right: 25px;
}
.info-body {
  padding: 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  max-height: 100%;
}
.h2 {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.7;
  letter-spacing: -0.1px;
  margin-top: 0;
  color: $black;
}
.sub-title {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/helper/dialog/Information.vue